import React from 'react';
import PropTypes from 'prop-types';
import Image from '@sportson/core-web/components/Image';
import Youtube from '@sportson/core-web/components/Youtube';
import styled from 'libs/styled';
import { above } from '@sportson/core-web/utils/mediaqueries';
import { stormSrc, generateSrcSet } from '@sportson/core-web/libs/image';

const ImageWrapper = styled('div')`
    height: 100%;
    user-select: none;
    width: 100%;
`;

const Video = styled('video')`
    object-fit: cover;
    width: 100%;
    height: 100%;
    min-width: 100%;
    min-height: 100%;
`;

const YouTubeWrapper = styled('div')`
    width: 100%;
    height: 100%;

    iframe {
        height: 100%;
        width: 100%;
        max-width: 100%;
        max-height: 100%;
    }
`;

const StyledVideoPlayIcon = styled('div')`
    position: absolute;
    left: 50%;
    top: 48%;
    transform: translate3d(-50%, 0, 0);
    z-index: 3;
    border: none;
`;

const GalleryCard = ({ media, isLazyLoading }) => {
    const youTubeImageId = media.youtube && media.youtube.split('/').pop();
    // At writing moment something in generateSrcSet or generateSizes seems to make them not work as should.
    const widths = [360, 460, 560, 660, 760, 860, 960, 1060, 1160, 1260, 1360];
    const imageSrc = stormSrc(`${media.image}.jpg`, { auto: 'format', q: 80, ar: '1', fit: 'fill' });
    const srcSet = generateSrcSet(imageSrc, widths);

    return (
        <>
            {imageSrc && (
                <ImageWrapper>
                    <Image
                        key={media.title}
                        draggable={false}
                        src={{ url: imageSrc, width: widths }}
                        srcSet={srcSet}
                        fallbackImageAsPlaceholder={false}
                        alt={media.title}
                        title={media.title}
                        lazyload={isLazyLoading}
                    />
                </ImageWrapper>
            )}

            {media.video && (
                <Video loop playsInline autoPlay muted key={media.video}>
                    <source src={media.video} type="video/mp4" />
                </Video>
            )}
            {media.youtube && (
                <YouTubeWrapper>
                    <Youtube
                        embedUrl={media.youtube}
                        thumbnailSrc={`https://img.youtube.com/vi/${youTubeImageId}/sddefault.jpg`}
                        loading="lazy"
                    >
                        <StyledVideoPlayIcon height="64px" width="64px" />
                    </Youtube>
                </YouTubeWrapper>
            )}
        </>
    );
};

GalleryCard.propTypes = {
    isLazyLoading: PropTypes.bool,
    media: PropTypes.shape({
        code: PropTypes.string,
        image: PropTypes.string,
        title: PropTypes.string,
        video: PropTypes.string,
        youtube: PropTypes.string,
    }).isRequired,
};

GalleryCard.defaultProps = {
    isLazyLoading: true,
};

export default GalleryCard;
